
import {
    ADD_LEAD_BUSINESS_ENTITY,
    ADD_LEAD_BUSINESS_ENTITY_SUCCESS,
    ADD_LEAD_BUSINESS_ENTITY_ERROR,
    UPDATE_LEAD_BUSINESS_ENTITY,
    UPDATE_LEAD_BUSINESS_ENTITY_SUCCESS,
    UPDATE_LEAD_BUSINESS_ENTITY_ERROR,
    DELETE_LEAD_BUSINESS_ENTITY,
    DELETE_LEAD_BUSINESS_ENTITY_SUCCESS,
    DELETE_LEAD_BUSINESS_ENTITY_ERROR,

} from "./actionTypes"
export const addLeadBusinessEntity = payload => {
    return {
        type: ADD_LEAD_BUSINESS_ENTITY,
        payload: payload,
    }
}

export const addLeadBusinessEntitySuccess = lead => {
    return {
        type: ADD_LEAD_BUSINESS_ENTITY_SUCCESS,
        payload: lead,
    }
}

export const addLeadBusinessEntityError = error => {
    return {
        type: ADD_LEAD_BUSINESS_ENTITY_ERROR,
        payload: error,
    }
}

export const updateLeadBusinessEntity = payload => {
    return {
        type: UPDATE_LEAD_BUSINESS_ENTITY,
        payload: payload,
    }
}

export const updateLeadBusinessEntitySuccess = lead => {
    return {
        type: UPDATE_LEAD_BUSINESS_ENTITY_SUCCESS,
        payload: lead,
    }
}

export const updateLeadBusinessEntityError = error => {
    return {
        type: UPDATE_LEAD_BUSINESS_ENTITY_ERROR,
        payload: error,
    }
}

export const deleteLeadBusinessEntity = payload => {
    return {
        type: DELETE_LEAD_BUSINESS_ENTITY,
        payload: payload,
    }
}

export const deleteLeadBusinessEntitySuccess = lead => {
    return {
        type: DELETE_LEAD_BUSINESS_ENTITY_SUCCESS,
        payload: lead,
    }
}

export const deleteLeadBusinessEntityError = error => {
    return {
        type: DELETE_LEAD_BUSINESS_ENTITY_ERROR,
        payload: error,
    }
}

  //Lead BusinessEntity//